import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { IconButtonCtaArrow } from '@components/atoms/icons'
import { convertToSlug } from '@utils/slugs'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme, styled } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import { CitysList } from './courses-in-state.styles'


const ExpandMore = styled((props) => {
  const { expand, ...rest } = props
  return <IconButton {...rest} />
})(({ theme, expand }) => ({
  '& svg': {
    transform: !expand ? 'rotate(90deg)' : 'rotate(270deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: '0.25rem',
  },
  '&:focus': {
    outline: 'none',
  },
  color: theme.palette.blue.main,
  paddingLeft: 0,
  ...theme.typography.subtitle1,
}))

const City = React.memo(({ stateCode, city, courseCount }) => (
  <li>
    <Link href={`/play/${stateCode}/${convertToSlug(city)}`}>
      {city} ({courseCount})
    </Link>
  </li>
))

const CoursesInState = React.memo((props) => {
  const [expanded, setExpanded] = React.useState(false)
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'))

  const handleExpandClick = () => {
    if (expanded) {
      window.scrollTo({ top: 100, behavior: 'smooth' })
    }
    setExpanded(prevState => !prevState)
  }

  const {
    cities = [],
    stateCode,
  } = props

  // For states with more than 10 cities, the list should collapse on mobile browsers.
  const useMore = isMobile && cities.length > 10

  return useMore ? (
    <CitysList data-testid="city-list">
      {cities.slice(0, 10).map(city => (
        <City {...city} stateCode={stateCode} key={`city-${city.city}`} />
      ))}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {cities.slice(10).map(city => (
          <City {...city} stateCode={stateCode} key={`city-${city.city}`} />
        ))}
      </Collapse>
      <ExpandMore
        expand={expanded}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label={`read ${expanded ? 'less' : 'more'}`}
      >
        Read {expanded ? 'Less' : 'More'}
        <IconButtonCtaArrow />
      </ExpandMore>
    </CitysList>
  ) : (
    <CitysList data-testid="city-list">
      {cities.map(city => (
        <City {...city} stateCode={stateCode} key={`city-${city.city}`} />
      ))}
    </CitysList>
  )
})

CoursesInState.propTypes = {
  stateCode: PropTypes.string,
  cities: PropTypes.arrayOf(PropTypes.shape({
    city: PropTypes.string,
    courseCount: PropTypes.number,
  })),
}

export default CoursesInState
